<template>
  <div class="property_wrap">
    <div class="pro_top">{{property.label}}设置</div>
    <div class="pro_con">
      <el-form label-width="80px">
        <el-form-item label="组件标题:">
          <el-input v-model="property.label"></el-input>
        </el-form-item>
      </el-form>
      <div class="teamlist-body" v-for="(item,index) in property.list" :key="index">
        <i class="el-icon-circle-close teamlist-body-i" @click="closeTeamList(index)"></i>
        <el-form ref="form" label-width="80px">
          <el-form-item label="头像">
            <div class="addicon">
              <div class="el-upload el-upload--text" @click="changeList(index)">
                <img v-if="item.pic" :src="item.pic" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </div> 
            <p>(图片大小不超过2M,支持jpg、png格式，最佳尺寸280x330px)</p>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="item.name" type="text"></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-input v-model="item.position" type="text"></el-input>
          </el-form-item>
          <el-form-item label="简介">
            <el-input v-model="item.info" type="textarea" maxlength="15"
                      show-word-limit ></el-input>
          </el-form-item>
          <el-form-item label="跳转名片">
            <el-radio-group v-model="item.is_link" @change="raidoChange(index)">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">跳转到成员名片</el-radio>
            </el-radio-group>
            <div class="btn-chooseteam" v-if="item.is_link==1">
              <el-input placeholder="请选择要关联的成员" v-model="item.uname" disabled>
                <el-button slot="append" @click="chooseCartId(index)" class="right_input_btn" :class="item.is_link==1?'right_input_btn_active':''">
                  关联成员
                </el-button>
              </el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <el-button @click="addUserTeam">添加人员</el-button>
    </div>
    <chooseManagerDialog
            :visible.sync="choosedepdialog"
            @userDetail="userDetail"
            v-if="choosedepdialog"
            :typeDialog="typeDialog"
            @choosedepsucess="choosedepsucess"
    ></chooseManagerDialog>
    <corpper :visible.sync="corppervisible"
          v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>
  </div>
</template>
<script>
  import api from "@/api.js";
  import chooseManagerDialog from "@/components/dialog/chooseManagerDialog.vue";
  import corpper from "@/components/dialog/corpper.vue";
  export default {
    props: ["property"],
    components: {
      chooseManagerDialog,corpper
    },
    data() {
      return {
        typeDialog: 1,
        choosedepdialog:false,
        dialogVisible: false,
        radio: 1,
        defultImg: '/static/img/userDefult.png',
        activeImg: 0,
        form: {
          label: '',
          list: []
        }, // list:[id:'',pic:'',name:'',position:'',info:'',is_link:'']
        corppervisible: false,
        imgSize: 10
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    created() {
      if(this.property.list.length===0){
        let team = {id: '', pic: this.defultImg, name: '', position: '', info: '', is_link: 0};
        this.form.list.push(team);
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
      choosedepsucess() {

      },
      addUserTeam() {
        let team = {id: '', pic: this.defultImg, name: '', position: '', info: '', is_link: 0};
        this.form.list.push(team);
      },
      closeTeamList(index) {
        this.form.list.splice(index, 1)
      },
      changeList(index) {
        this.activeImg = index
        this.corppervisible = true
      },
      raidoChange(index){
        if(this.form.list[index].is_link!==1){
          this.form.list[index].id = ''
          this.form.list[index].uname = ''
        }
      },
      // 选择用户
      chooseCartId(index) {
        this.clickIndex = index;
        this.choosedepdialog = true;
      },
      userDetail(option) {
        this.form.list[this.clickIndex].id = option.id
        this.form.list[this.clickIndex].name = option.name
        this.form.list[this.clickIndex].uname = option.name
        this.choosedepdialog = false
      },
      imgAddBack(option) {
        this.property.list[this.activeImg].pic = option
        this.form.list[this.activeImg].pic = option
      }
    }
  };
</script>

<style scoped>
.addicon .avatar{width: 120px; height: 141px; object-fit: cover;}
</style>